import palette from '../../palette';

export default {
  root: {
    '&$selected': {
      backgroundColor: palette.greenMiddle
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.03)'
      }
    }
  }
};
